import React, { useMemo } from 'react';
// import { Box, Stack } from '@mantine/core';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
// import { data } from './trainingProgData';
// import { data } from './makeData2';

const NegNameTraineeScoreTable = ({ data, reactVerbosity }) => {
  // console.log('NegNameTraineeScoreTable RENDERING', data);
  data.forEach((s, i) => {
    // console.log("s.userScore:",s.userScore)
    let userScoreStr = '';
    if (typeof s.userScore === 'string' && s.userScore.includes('/')) {
      const userScoreArr = s.userScore && s.userScore.split('/');
      // userScoreStr = `${userScoreArr[0]}/${s.maxScore}`;
      userScoreStr = ((parseInt(userScoreArr[0])/s.maxScore) * 100).toFixed();
      userScoreStr = `${userScoreStr}%`;
    } else {
      // userScoreStr = `${s.userScore}/${s.maxScore}`;
      userScoreStr = ((s.userScore/s.maxScore) * 100).toFixed();
      userScoreStr = `${userScoreStr}%`;
    }
    data[i].userScoreNew = userScoreStr;
  });

  reactVerbosity >= 4 && console.log('###################> NegNameTraineeScoreTable DATA:', data);
  const columns = useMemo(() => [
    {
      header: 'Negotiation',
      accessorKey: 'negotiation',
      enableGrouping: true,
      size: 200,
    },
    {
      header: 'Trainee',
      accessorKey: 'user',
      size: 150,
    },
    {
      header: 'Region',
      accessorKey: 'region',
      size: 100,
    },
    {
      header: 'Score',
      accessorKey: 'userScoreNew',
      size: 100,
    },
    {
      accessorKey: 'date',
      header: 'Date',
      size: 140,
    }
  ]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    enableGrouping: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    initialState: {
      density: 'xs',
      expanded: true,
      grouping: ['negotiation'],
      pagination: { pageIndex: 0, pageSize: 20 },
      sorting: [{ id: 'negotiation', desc: false }]
    },
    mantineTableContainerProps: { 
      sx: { 
        height: '64%',
        maxHeight: 'calc(80vh * 0.8)',
        paddingLeft: '16px',
        paddingRight: '16px',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
      } 
    },
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnDragging: false,
    mantineTopToolbarProps: {
      sx: {
        backgroundColor: 'white',
        borderRadius: '8px 8px 0 0',
        paddingTop: '0px',
        marginTop: '8px',
        marginBottom: '0px',
      },
    },
    mantineTableProps: {
      sx: {
        borderRadius: '8px 8px 0 0',
        overflow: 'hidden',
        flex: 1,
      },
    },
    mantineToolbarAlertBannerProps: {
      color: 'blue',
    },
    positionToolbarAlertBanner: 'bottom',
    mantinePaperProps: {
      sx: {
        '& .mantine-ActionIcon-root': {
          backgroundColor: '#e9ecef !important',
          borderRadius: '8px !important',
          margin: '0 4px',
          width: '32px !important',
          height: '32px !important',
          '&:hover': {
            backgroundColor: '#dee2e6 !important',
          },
          '& svg': {
            width: '16px !important',
            height: '16px !important',
          },
        },
        '& .mantine-TableFooter-root': {
          backgroundColor: '#e9ecef !important',
        },
        '& .mantine-TableFooter-root td': {
          fontWeight: 'bold !important',
          color: '#333 !important',
          padding: '12px 16px !important',
        },
        '& .mantine-Table-root + div': {
          backgroundColor: '#e9ecef !important',
          padding: '8px 16px',
          borderRadius: '0 0 8px 8px',
        },
      },
    },
    mantineTableHeadCellProps: {
      sx: {
        backgroundColor: '#e9ecef',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        color: '#333',
        padding: '8px 6px',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        padding: '8px 6px',
      },
    },
    icons: {
      IconColumns: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="18px"
          height="18px"
        >
          <path d="M0 0h24v24H0z" fill="none"/>
          <circle cx="3.5" cy="7" r="1.5"/>
          <rect x="8" y="6" width="13" height="2"/>
          <circle cx="3.5" cy="12" r="1.5"/>
          <rect x="8" y="11" width="13" height="2"/>
          <circle cx="3.5" cy="17" r="1.5"/>
          <rect x="8" y="16" width="13" height="2"/>
        </svg>
      ),
      IconFilter: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="18px"
          height="18px"
        >
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
      ),
      IconSearch: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="18px"
          height="18px"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      )
    },
    mantineBottomToolbarProps: {
      sx: {
        backgroundColor: '#e9ecef !important',
        borderRadius: '0 0 8px 8px',
        margin: '8px 16px',
      },
    },
  });

  return (
    <div className="custom-table-wrapper">
      <style jsx>{`
        .custom-table-wrapper :global(tfoot tr) {
          background-color: #e9ecef !important;
        }
        .custom-table-wrapper :global(tfoot td) {
          font-weight: bold !important;
          color: #333 !important;
          padding: 12px 16px !important;
        }
      `}</style>
      <MantineReactTable table={table} />
    </div>
  );
};

export default React.memo(NegNameTraineeScoreTable);
